const API_BASE = String(import.meta.env.VITE_API_BASE || '').replace(/\/$/, '');

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number
  ) {
    super(message);
  }
}

export function getAdminToken(): string {
  return sessionStorage.getItem('sky-v2-admin-token') || '';
}

export function setAdminToken(token: string): void {
  const value = token.trim();
  if (value) sessionStorage.setItem('sky-v2-admin-token', value);
  else sessionStorage.removeItem('sky-v2-admin-token');
}

export async function api<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body) headers.set('content-type', 'application/json');
  const token = getAdminToken();
  if (token) headers.set('x-admin-token', token);

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers
  });
  const payload = await response.json().catch(() => ({})) as {
    error?: string;
  };
  if (!response.ok) {
    throw new ApiError(payload.error || `http_${response.status}`, response.status);
  }
  return payload as T;
}

